<!--赖传峰-->
<!--2022/1/29-->
<!--eslint-disable max-len-->
<template>
  <div
    v-if="ipBlock"
    class="ip-blocked"
  >
    <div class="content">
      <svg
        fill="none"
        height="163"
        viewBox="0 0 241 163"
        width="241"
        xmlns="http://www.w3.org/2000/svg"
      >
        <ellipse
          cx="120.891"
          cy="123.027"
          fill="url(#paint0_radial_2405_18122)"
          rx="120"
          ry="39.4839"
        />
        <path
          clip-rule="evenodd"
          d="M150.043 102.759C160.067 101.763 167.895 93.3051 167.895 83.0194V39.8154H161.259V86.3296C161.259 93.804 156.609 100.192 150.043 102.759Z"
          fill="#D8DFEF"
          fill-rule="evenodd"
        />
        <path
          clip-rule="evenodd"
          d="M65.7363 22.1201H82.3262C82.937 22.1201 83.6682 22.6153 83.9594 23.2261L91.5818 39.816C89.9228 39.816 74.9722 39.816 72.78 39.816L65.1576 23.2261C64.8664 22.6153 65.1255 22.1201 65.7363 22.1201Z"
          fill="#D3D9E4"
          fill-rule="evenodd"
        />
        <path
          d="M152.539 63.3327C152.539 63.3327 173.054 66.4946 182.499 54.1105C191.945 41.7264 185.915 31.7499 185.915 31.7499"
          stroke="#D3D9E4"
          stroke-dasharray="17.63 1.1"
          stroke-width="5.51042"
        />
        <path
          d="M172.677 19.3841C171.215 24.8045 174.428 30.3697 179.853 31.8141C185.278 33.2586 190.861 30.0354 192.322 24.6149C193.784 19.1945 190.571 13.6294 185.146 12.1849"
          stroke="#D3D9E4"
          stroke-linecap="round"
          stroke-width="5.51042"
        />
        <path
          d="M75.6397 59.427C75.6397 59.427 66.5302 57.9583 58.2577 68.18C49.9851 78.4017 55.8807 90.6006 55.8807 90.6006"
          stroke="#D3D9E4"
          stroke-dasharray="17.63 1.1"
          stroke-width="5.51042"
        />
        <path
          d="M70.2104 103.382C71.672 97.9611 68.4589 92.396 63.0339 90.9515C57.6089 89.507 52.0261 92.7302 50.5646 98.1507C49.103 103.571 52.316 109.136 57.741 110.581"
          stroke="#D3D9E4"
          stroke-linecap="round"
          stroke-width="5.51042"
        />
        <path
          clip-rule="evenodd"
          d="M72.7799 39.8164H167.895V91.837C167.895 97.9237 162.961 102.858 156.874 102.858H83.8007C77.7141 102.858 72.7799 97.9237 72.7799 91.837V39.8164Z"
          fill="#ECF0F9"
          fill-rule="evenodd"
        />
        <path
          clip-rule="evenodd"
          d="M173.711 57.5117H157.121C156.51 57.5117 155.779 57.0165 155.488 56.4057L147.434 39.8159C148.54 39.8159 165.774 39.8159 167.895 39.8159L174.29 56.4057C174.581 57.0165 174.322 57.5117 173.711 57.5117Z"
          fill="#D3D9E4"
          fill-rule="evenodd"
        />
        <rect
          fill="#1E3559"
          height="17.6959"
          rx="4.42396"
          width="8.84793"
          x="102.642"
          y="51.9814"
        />
        <rect
          fill="#1E3559"
          height="17.6959"
          rx="4.42396"
          width="8.84793"
          x="129.186"
          y="51.9814"
        />
        <path
          d="M140.245 9.00577C140.245 13.9796 136.213 18.0117 131.24 18.0117H129.028L126.026 21.0137L123.024 18.0117H120.812C115.838 18.0117 111.806 13.9796 111.806 9.00577V9.00577C111.806 4.03194 115.838 -0.000152707 120.812 -0.000152707L131.24 -0.000152707C136.213 -0.000152707 140.245 4.03194 140.245 9.00577V9.00577Z"
          fill="#D3D9E4"
        />
        <path
          d="M122.55 5.53027L130.292 12.1662"
          stroke="white"
          stroke-width="1.10208"
        />
        <path
          d="M130.292 5.53027L122.55 12.1662"
          stroke="white"
          stroke-width="1.10208"
        />
        <defs>
          <radialGradient
            id="paint0_radial_2405_18122"
            cx="0"
            cy="0"
            gradientTransform="translate(120.891 88.0294) rotate(90) scale(48.8084 405.327)"
            gradientUnits="userSpaceOnUse"
            r="1"
          >
            <stop stop-color="#F2F1F6" />
            <stop
              offset="1"
              stop-color="#DDE3F1"
              stop-opacity="0.01"
            />
          </radialGradient>
        </defs>
      </svg>
      <h1>{{ ipBlock.prompt.title }}</h1>
      <div class="detail">
        <p>
          {{ ipBlock.prompt.body }}
        </p>
      </div>
      <div class="support">
        <a
          v-for="el in ipBlock.prompt.redirect"
          :key="el.url"
          :href="el.url"
          target="_blank"
        >
          {{ el.title }}
        </a>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { computed } from '#imports'
import { useUserInfo } from '@/store/userInfo'

const ipBlock = computed(() => useUserInfo().ipBlock)
</script>
<style lang="less" scoped>
.ip-blocked {
  background: #fff;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.content {
  padding: 0 10px;
  line-height: 25px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  h1 {
    font-weight: 400;
    font-size: 18px;
  }

  .detail {
    margin-top: 16px;
    color: var(--color-secondary-text);

    p + p {
      margin-top: 4px;
    }
  }

  > div {
    margin-top: 16px;
  }
}

.support {
  a + a {
    margin-left: 12px;
  }
}

@media screen and (max-width: 320px) {
  svg {
    display: none;
  }
}
</style>
